import httpClient from "./index";

const END_POINT = "pointers";

const pointers = () => httpClient.get(END_POINT);

export { pointers };
